import { setStatsEnabled, toggleStats } from './actions'
import reducer from './reducer'
import Stats from './containers/Stats'
import FPSMeter from './containers/FPSMeter'

export { setStatsEnabled, toggleStats, reducer, Stats, FPSMeter }
